var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BlBackdrop", { attrs: { footer: false } }, [
    _c(
      "div",
      { staticClass: "flex flex-col gap-4 py-8", style: { width: "64rem" } },
      [
        _c(
          "div",
          { staticClass: "px-8 flex items-center justify-between" },
          [
            _c("BlTextTitle4", { attrs: { text: "Invite new bulk members" } }),
            _vm._v(" "),
            _c("BlInputButton", {
              attrs: { type: "outlined", icon: "plus", label: "New member" },
              on: { clicked: _vm.onNewMember }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "px-8 flex flex-col overflow-y-auto",
            style: { height: "calc(100vh - 24rem)" }
          },
          _vm._l(_vm.usersInput, function(user, idx) {
            return _c(
              "div",
              {
                key: user.id,
                staticClass:
                  "py-3 flex items-center gap-2 border-b border-slate-400"
              },
              [
                _c("BlInputText", {
                  attrs: {
                    input: { placeholder: "Name", model: user.nameInput }
                  },
                  on: {
                    changed: function($event) {
                      return _vm.onInputName(idx, $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass: "w-full",
                    attrs: {
                      tooltip: user.emailError
                        ? "<div class='w-60'>" + user.emailError + "</div>"
                        : ""
                    }
                  },
                  [
                    _c("BlInputText", {
                      attrs: {
                        input: {
                          placeholder: "Email",
                          inputType: "email",
                          model: user.emailInput,
                          error: user.emailError ? "true" : "",
                          suffix: user.emailError
                            ? "\n                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>\n                    <path fill-rule='evenodd' clip-rule='evenodd' d='M9.401 3.00305C10.556 1.00305 13.444 1.00305 14.598 3.00305L21.953 15.7511C23.107 17.7511 21.663 20.2511 19.354 20.2511H4.645C2.336 20.2511 0.892995 17.7511 2.047 15.7511L9.4 3.00305H9.401ZM12 8.25005C12.1989 8.25005 12.3897 8.32907 12.5303 8.46972C12.671 8.61037 12.75 8.80114 12.75 9.00005V12.7501C12.75 12.949 12.671 13.1397 12.5303 13.2804C12.3897 13.421 12.1989 13.5001 12 13.5001C11.8011 13.5001 11.6103 13.421 11.4697 13.2804C11.329 13.1397 11.25 12.949 11.25 12.7501V9.00005C11.25 8.80114 11.329 8.61037 11.4697 8.46972C11.6103 8.32907 11.8011 8.25005 12 8.25005ZM12 16.5001C12.1989 16.5001 12.3897 16.421 12.5303 16.2804C12.671 16.1397 12.75 15.949 12.75 15.7501C12.75 15.5511 12.671 15.3604 12.5303 15.2197C12.3897 15.0791 12.1989 15.0001 12 15.0001C11.8011 15.0001 11.6103 15.0791 11.4697 15.2197C11.329 15.3604 11.25 15.5511 11.25 15.7501C11.25 15.949 11.329 16.1397 11.4697 16.2804C11.6103 16.421 11.8011 16.5001 12 16.5001Z' fill='#DD3F30'/>\n                  </svg>\n                "
                            : ""
                        }
                      },
                      on: {
                        changed: function($event) {
                          return _vm.onInputEmail(idx, $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BlSelectBox", {
                  staticClass: "max-w-72",
                  attrs: {
                    placeholder: "Select role",
                    options: _vm.roleOptions
                  },
                  on: {
                    change: function($event) {
                      _vm.usersInput[idx].roleInput = $event
                    }
                  },
                  model: {
                    value: _vm.usersInput[idx].roleInput,
                    callback: function($$v) {
                      _vm.$set(_vm.usersInput[idx], "roleInput", $$v)
                    },
                    expression: "usersInput[idx].roleInput"
                  }
                }),
                _vm._v(" "),
                _c("BlInputButton", {
                  attrs: {
                    type: "outlined-error",
                    icon: "delete",
                    dense: "",
                    disabled: _vm.usersInput.length < 2
                  },
                  on: {
                    clicked: function($event) {
                      return _vm.onRemoveMember(user.id)
                    }
                  }
                })
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "px-8 flex items-center justify-between" }, [
          _c(
            "div",
            { staticClass: "flex flex-col" },
            [
              _c("BlTextTitle4", {
                staticClass: "text-light-purple",
                attrs: { text: _vm.usersInput.length }
              }),
              _vm._v(" "),
              _c("BlTextBody2", { attrs: { text: "New member(s) invited" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center gap-4" },
            [
              _c("BlInputButton", {
                attrs: { type: "plain", label: "Cancel" },
                on: {
                  clicked: function($event) {
                    return _vm.$emit("close-modal")
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: {
                  label: "Generate invitation link",
                  loading: _vm.submitLoading,
                  disabled: _vm.isDisabledSubmit
                },
                on: { clicked: _vm.onSubmit }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11d63233", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11d63233","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/center/centerTeam/InviteManualBulkUserModal.vue
// module id = null
// module chunks = 